import { Divider, Stack } from '@mui/material';
import { type PropsWithChildren } from 'react';

import { ParentBlockSelectField } from '../../../ConfigFields/SelectField.tsx';
import { FlowKind, type SharedBlockFormFieldsProps } from '../../constants.tsx';
import { FlowVersionFormFields } from '../Shared/FlowVersion.tsx';

type SharedSubFlowBlockFormFieldsProps = Pick<SharedBlockFormFieldsProps, 'fieldNamePrefix'> &
  PropsWithChildren;

export function SharedSubFlowV1BlockFormFields(props: SharedSubFlowBlockFormFieldsProps) {
  const { fieldNamePrefix } = props;
  return (
    <Stack gap={2}>
      <FlowVersionFormFields
        fieldNamePrefix={fieldNamePrefix}
        variant="SubflowPicker"
        allowedFlowKinds={[FlowKind.Base]}
      >
        <ParentBlockSelectField
          fieldName={`${fieldNamePrefix}.startDataBlockName`}
          label="Start Data"
          helperText="Optionally pass the output of a single block from this flow into the child flow"
        />
        <Divider variant="middle" />
      </FlowVersionFormFields>
    </Stack>
  );
}
